import React, { useCallback, useEffect, useState } from 'react'

import clsx from 'clsx'

import { BaseButton } from 'components/Button'
import Icon from 'components/Icon'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'
import debounce from 'helpers/debounce'

import classes from './BackToTop.module.scss'

const BackToTop = ({ children, className }) => {
  const [isTop, setIsTop] = useState(true)
  const { addEvent } = useEventContext({
    engagementComponent: 'back-to-top',
  })
  const { isCypressTakingSnapshots } = useAppContext()

  const onGoToTop = useCallback(() => {
    window.location.hash = ''
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    const handleScroll = () => setIsTop(window.scrollY < 200)
    window.addEventListener('scroll', debounce(handleScroll, isCypressTakingSnapshots ? 0 : 100), false)
    return () => window.removeEventListener('scroll', handleScroll, false)
  }, [isCypressTakingSnapshots])

  return (
    <div
      className={clsx('BackToTop', classes.root, className, {
        [classes.visible]: !isTop,
        [classes.withSticky]: !isCypressTakingSnapshots,
      })}
    >
      {children}
      <BaseButton
        onClick={onGoToTop}
        className={clsx(classes.chip, 'evnt')}
        {...addEvent({
          engagementDestination: 'jump-to_top',
          engagementDetails: 'button_back-to-top',
          name: 'engagement_navigation',
        })}
      >
        <Icon size={14} icon={['far', 'arrow-to-top']} className={classes.icon} />
        <span className={classes.label}>Back to top</span>
      </BaseButton>
    </div>
  )
}

export default BackToTop
